import * as React from "react";
const SvgRightArrow = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 78 47",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fill: "currentColor",
	d: "m41.476 11.709 13 7.395C37.638 45.233 14.238 46.219 0 43.138c29.714 11.708 55.714-5.752 64.381-18.488L78 32.045 71.81 0z"
}));
export default SvgRightArrow;
